module.exports = __webpack_public_path__ + "img/back_blue.c42dbec4.svg";